var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSupported
    ? _c(
        "button",
        {
          staticClass: "button360 btn btn-outline-light",
          on: { click: _vm.toggle },
        },
        [
          _c("img", {
            attrs: {
              src: _vm.icon,
              title: _vm.$translate(
                "modeherz::SingleItemPageClient.itemPageStart360View"
              ),
              alt: _vm.$translate(
                "modeherz::SingleItemPageClient.itemPageStart360View"
              ),
            },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }